import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../types/multi-error';
import { graphqlClient } from '../graphql-client';

const MUTATION = gql`
    mutation EmotionEpisodeLink($uid: String!, $type: String){
        video_service_locator_set (uid: $uid, type: $type) {
            url
        }
    }
`;

export async function emotionEpisodeLink(uid: string, type?: string): Promise<string> {
    const result: FetchResult<{ video_service_locator_set: { url: string }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid, type },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.video_service_locator_set.url;
}
